import {
  FiMonitor,
  FiTrendingUp,
  FiShield,
  FiBarChart2,
  FiCloud,
  FiBox,
  FiCode,
  FiLayers,
  FiPenTool,
  FiSettings,
} from "react-icons/fi";

export const company = {
  name: "VrajPath iTech LLP",
  shortName: "vrajpath",
  motto: ["Believe", "Make", "Own."],
  tagline: "Collaboration | Innovation – Simplified.",
  established: "2022",
  description:
    "A trailblazing software company redefining the digital landscape for businesses across diverse industries.",
  address:
    "Eccosphere Coworking, Block B, Sector-67, Noida, Uttar Pradesh 201309, India",
  email: "social@vrajpath.com",
  supportEmail: "support@vrajpath.com",
  phone: "+91-9818527999",
  website: "https://www.vrajpath.com",
  websiteDisplay: "www.vrajpath.com",
};

export const hero = {
  eyebrow: "Software development",
  headline: "Build digital products that move your business forward",
  headlineAccent: "move your business forward",
  subheadline:
    "From idea to scale—we craft high-performance web and mobile products powered by cloud and data, helping startups and businesses grow faster.",
  primaryCta: { label: "Start a project", path: "/enquiry" },
  secondaryCta: { label: "View services", path: "/services" },
};

export const stats = [
  { value: "15+", label: "Growing business with us" },
  { value: "65+", label: "Projects delivered on time" },
  { value: "30+", label: "Indian & abroad clients coverage" },
];

export const introduction = {
  title: "Introduction",
  paragraphs: [
    "Welcome to VrajPath iTech LLP – where innovation meets technology, and possibilities become solutions. As a trailblazing software company, we embark on a journey to redefine the digital landscape for businesses across diverse industries. Established in '22 with a vision that envisions digital transformation as a catalyst for success, VrajPath iTech LLP is committed to pushing the boundaries of what's possible in the realm of software solutions.",
    "At VrajPath iTech LLP, we recognize that in the ever-evolving world of technology, staying ahead is not just an advantage but a necessity. Our dynamic and forward-thinking approach positions us as a reliable partner for organizations seeking not just software, but a strategic ally in their pursuit of excellence. Through a fusion of expertise, creativity, and cutting-edge technology, we propel businesses toward a future where innovation is the norm and success is inevitable.",
    "Our journey is marked by a passion for technology and a commitment to delivering unparalleled software solutions. From inception to implementation, we go beyond conventional boundaries to craft customized solutions that align seamlessly with the unique needs and aspirations of each client. VrajPath iTech LLP is not just a software company; it's a gateway to possibilities, a conduit to digital transformation, and a beacon guiding businesses toward a future where technology is a powerful ally, not just a tool.",
  ],
};

/** Short copy for the homepage */
export const aboutSummary = {
  title: "A technology partner, not just a vendor",
  lead: "We help businesses redefine what's possible with software—from web and mobile products to cloud, analytics, and security—so you can focus on growth while we handle the build.",
  body: "Established in 2022, we combine expertise, creativity, and modern engineering to deliver solutions tailored to each client's goals. Think of us as a strategic ally, not just another dev shop.",
};

export const vision = {
  title: "Our Vision",
  intro:
    "At VrajPath iTech LLP, our vision extends beyond the development of cutting-edge software solutions—it encompasses a commitment to fostering and empowering the journeys of new startups. We recognize that startups are the lifeblood of innovation, representing the audacious dreams that shape the future. We aspire to be the catalyst that propels these startups from ideation to success, navigating the challenges of the digital landscape with confidence.",
  points: [
    {
      title: "Empowering Startups",
      description:
        "We aim to empower startups by providing them with cutting-edge software solutions tailored to their unique needs.",
    },
    {
      title: "Strategic Guidance",
      description:
        "Beyond technology, our mission includes offering strategic support and guidance to startups, aligning their tech initiatives with business objectives.",
    },
    {
      title: "Nurturing Inspiring Journeys",
      description:
        "We take pride in being part of the inspiring journeys of startups, creating an environment that supports and encourages their growth.",
    },
    {
      title: "Collaborative Ecosystem",
      description:
        "Our mission involves fostering a collaborative ecosystem where startups can thrive through partnerships, shared knowledge, and opportunities for growth.",
    },
    {
      title: "Contributing to Success Stories",
      description:
        "We envision startups not just surviving but flourishing, leaving a lasting impact on the digital landscape with their innovative solutions.",
    },
    {
      title: "Trusted Partner",
      description:
        "As a trusted partner, our mission is to guide startups in navigating challenges, embracing innovation, and emerging stronger and more resilient.",
    },
  ],
};

export const process = [
  {
    step: "01",
    title: "Discovery",
    description:
      "We begin by getting to know our clients and understanding their goals, needs and expectations.",
    featured: true,
  },
  {
    step: "02",
    title: "Strategy",
    description:
      "We develop a strategy that outlines the course of action for achieving our client's objectives.",
  },
  {
    step: "03",
    title: "Design",
    description:
      "We create a clean UI design that meets their needs and aligns with their brand with user experience.",
  },
  {
    step: "04",
    title: "Develop",
    description:
      "We bring design to life, creating a fully functional scalable product that meets the project requirements.",
  },
];

export const servicesIntro =
  "At VrajPath iTech LLP, our services are a testament to a commitment to excellence, innovation, and client-centric solutions. With a focus on delivering transformative outcomes, our diverse range of services caters to the dynamic needs of businesses navigating the digital landscape.";

export const services = [
  {
    icon: FiMonitor,
    title: "Mobile & Web Application Development",
    description:
      "Trusted provider of custom mobile and web application development services, delivering cutting-edge solutions to clients across industries.",
  },
  {
    icon: FiTrendingUp,
    title: "Business Development & Digital Marketing",
    description:
      "Comprehensive marketing strategies designed to help clients achieve their growth goals with effective outcomes and innovative solutions.",
  },
  {
    icon: FiShield,
    title: "Quality Assurance & Security Audits",
    description:
      "Expert quality assurance and security audits for reliable and secure systems with comprehensive assessments to guarantee safety.",
  },
  {
    icon: FiBarChart2,
    title: "Data Analytics & Data Mining Tools",
    description:
      "Advanced tools that enable businesses with valuable insights, real-time data visualization and analysis for informed decisions.",
  },
  {
    icon: FiCloud,
    title: "Cloud Computing & Web Hosting",
    description:
      "Reliable and secure cloud computing and web hosting offering seamless, scalable and cost-effective integration with your infrastructure.",
  },
  {
    icon: FiBox,
    title: "3D Modeling & Development",
    description:
      "Precise digital modeling with efficient production of physical prototypes, enabling accelerated product development and design iterations.",
  },
];

export const technicalSkills = {
  title: "Technical Skills",
  intro:
    "We stay at the forefront of technology trends, ensuring our clients receive innovative solutions that position them for success in the ever-evolving digital landscape.",
  items: [
    {
      icon: FiCode,
      title: "Custom Software Development",
      description:
        "Crafted to meet unique business needs using Node.js, Java, and Python.",
      tags: ["Node.js", "Java", "Python"],
    },
    {
      icon: FiLayers,
      title: "Web & Mobile App Development",
      description:
        "From responsive websites to cross-platform mobile applications.",
      tags: ["React", "Angular", "React Native", "Ionic", "Flutter"],
    },
    {
      icon: FiCloud,
      title: "Cloud Solutions",
      description:
        "Migration, hosting, and optimization across major cloud platforms.",
      tags: ["AWS", "Azure", "Google Cloud"],
    },
    {
      icon: FiPenTool,
      title: "UI/UX Design",
      description:
        "Visually appealing interfaces and graphic design for digital products.",
      tags: ["Sketch", "Figma", "Adobe Creative Suite"],
    },
    {
      icon: FiSettings,
      title: "Data Analytics & Game Development",
      description:
        "Big data analytics and immersive game development capabilities.",
      tags: ["Hadoop", "Apache Spark", "Unity", "Unreal Engine 5", "Blender"],
    },
  ],
};

export const benefits = {
  title: "Your business needs",
  intro:
    "We support startups through launch and beyond—with perks that help you grow with confidence.",
  items: [
    {
      title: "Business Consultation",
      description:
        "Business consultation during product development for business and marketing strategies.",
    },
    {
      title: "Digital Marketing & Company Branding",
      description:
        "Customized plans specifically created for different phases of a startup.",
    },
    {
      title: "DevOps & Product Maintenance",
      description:
        "2 months of DevOps and product maintenance support after go-live, followed by services at nominal charges.",
    },
    {
      title: "Legal Operations",
      description:
        "Support for trademark registrations, company registrations, and ITR filings through collaboration with legal entities.",
    },
    {
      title: "Security Audits",
      description:
        "Security audit certifications for software products and web portals.",
    },
  ],
};

export const clients = {
  quote:
    "Majority of companies outsource their development work so they can focus on business. We have a strong development team who deliver on a contract basis.",
  logos: ["GlobalBees", "Instinct"],
};

export const cta = {
  title: "Ready to transform your business?",
  description:
    "Connect with VrajPath iTech LLP—your partner for innovation, simplified.",
  button: { label: "Get Started", path: "/enquiry" },
};

export const navLinks = [
  { label: "Home", path: "/" },
  { label: "About", path: "/#about" },
  { label: "Services", path: "/services" },
  { label: "Contact", path: "/contact" },
];

export const sectionNav = [
  { label: "Introduction", id: "introduction" },
  { label: "Our Vision", id: "vision" },
  { label: "How We Work", id: "how-we-work" },
  { label: "Our Services", id: "services" },
  { label: "Technical Skills", id: "technical-skills" },
  { label: "Benefits", id: "benefits" },
  { label: "Contact", path: "/contact" },
];

export const socialLinks = [
  { label: "LinkedIn", icon: "fa-linkedin-in", href: "https://www.linkedin.com/company/vrajpath-itech-llp/" },
  { label: "Instagram", icon: "fa-instagram", href: "https://www.instagram.com/vrajpath/" },
];

// Map coordinates — Eccosphere Coworking, Sector 67, Noida
export const mapCenter = { lat: 28.6012, lng: 77.3856 };

/** Top 3 vision points for homepage */
export const whyUs = vision.points.slice(0, 3);

export const allTechTags = technicalSkills.items.flatMap((item) => item.tags);
